function global() {

}

export default global;
